'use client';

import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import { useTranslations } from 'next-intl';
import { Suspense } from 'react';
import '@/styles/responsive/contact.css';

export default function ContactPage() {
  const t = useTranslations('contact');

  return (
    <div className="flex min-h-screen flex-col bg-white font-sans">
      <Suspense
        fallback={
          <div className="fixed top-0 right-0 left-0 z-50 h-[72px] border-zinc-100 border-b bg-white shadow-sm" />
        }
      >
        <Header />
      </Suspense>
      <main id="main-content" className="dark flex-1 bg-[#212120] pt-[100px] pb-12 text-white">
        <section className="contact">
          <div className="container">
            <div className="contact-page-wrapper mx-auto max-w-xl">
              <ContactSection />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
